import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { shallowEqual, useSelector } from 'react-redux'
import { format } from 'date-fns'

import { Button } from '@mui/material'
import { dateTimeTableFormat } from '@/constants/date'
import {
  useTransactions,
  useTransactionsActions,
  PlayerTransactionTableItem,
} from '../../hooks'
import { PlayerTransactionItem } from '@/state/player-transactions/models'

import { playerTransactionsSelector } from '@/state/player-transactions/slices/index.slices'

import { TableGenericComponent } from '@/views/components'
import { TransactionsTableStandardRow } from './'
import { TransactionDetailsModal } from '../details/transaction-details-modal.component'

type Props = {
  handleChangePage: (newPage: number) => void
  handleChangeLimit: (newLimit: number) => void
}

export const TransactionTableComponent = ({
  handleChangePage,
  handleChangeLimit,
}: Props) => {
  const { t } = useTranslation()

  const {
    isLoading,
    sortedRows,
    createSortHandler,
    getXlsFormattedRow,
    order,
    orderBy,
    headCells,
    pagination,
  } = useTransactions()

  const { getAllTransactions } = useTransactionsActions()

  const { filters } = useSelector(playerTransactionsSelector, shallowEqual)

  const [openDetail, setOpenDetail] = useState(false)
  const [selectedTransaction, setSelectedTransaction] =
    useState<PlayerTransactionItem | null>(null)

  const handleViewDetails = (row: PlayerTransactionTableItem) => {
    setSelectedTransaction(row as unknown as PlayerTransactionItem)
    setOpenDetail(true)
  }

  const body = sortedRows.map((row: PlayerTransactionTableItem) => {
    return (
      <TransactionsTableStandardRow
        key={row.externalTransactionId}
        row={row}
        onViewDetails={handleViewDetails}
      />
    )
  })

  const fileName = `transactions-wallets-${format(
    new Date(),
    dateTimeTableFormat,
  )}`

  const xlsxButton = (
    <Button
      onClick={() =>
        getAllTransactions(
          {
            ...filters,
            page: 1,
            limit: 999999,
            xlsx: true,
          },
          headCells,
          fileName,
          getXlsFormattedRow,
        )
      }
      variant="contained"
    >
      {t('labels.downloadAsXLS')}
    </Button>
  )

  return (
    <>
      <TableGenericComponent<PlayerTransactionTableItem>
        order={order}
        orderBy={orderBy}
        headCells={headCells}
        rowLength={sortedRows.length}
        pagination={pagination}
        isLoading={isLoading}
        body={body}
        hasAction={false}
        leftContent={xlsxButton}
        createSortHandler={createSortHandler}
        handleChangePage={handleChangePage}
        handleChangeLimit={handleChangeLimit}
      />
      <TransactionDetailsModal
        open={openDetail}
        onClose={() => setOpenDetail(false)}
        transaction={selectedTransaction}
      />
    </>
  )
}
